import React from 'react';
import LiquidEther from './LiquidEther';

const Background = () => {
  return (
    <div className="background">
      <LiquidEther
  colors={['#ff0000', '#a21515', '#a21515']}
  mouseForce={20}
  cursorSize={300}
  autoDemo={true}
  style={{ width: '100%', height: '1080px', position: 'fixed', top: 0, left: 0, zIndex: -1 }}
/>
    </div>
  );
};

export default Background; 